export const service = {


    publicityManage:{
        url:'/api/publicitymanage/publicityInfo/mlbilelist',//  线上用
        method: 'get',
        site: 0
    },

    // 活动列表
    marketingActivity_list:{
        url:'/marketing/marketingActivity/list',
        method: 'get',
        site: 1
    },
    marketingQuestionnaire_list:{
        url:'/marketing/questionnaire/list',
        method: 'get',
        site: 1
    },

    // 西藏开奖信息

    lottery_drawwinNumber_list:{
        url:'/lottery/drawwinNumber/list',
        method: 'get',//
        site: 2
    },
    lottery_drawwinNumber_detailes:{
        url:'/lottery/drawwinNumber/detailes',
        method: 'post',//
        site: 2
    },
    lottery_winbullInfo_windetailes:{
        url:'/lottery/winbullInfo/windetailes',
        method: 'post',//
        site: 2
    },



    // 注册
    salespersonInfo_register:{
        url:'/xzs/salespersonInfo/register',//销售员注册
        method: 'post',
        site: 1,
        // noTrans: true,//json对象格式
    },
    weChatScan_preScan:{
        url:'/api/weChat/info/wxconfig',//  线上用
        // url:'/api/lottery/weChat/info/wxconfig',//  本地用
        method: 'get',
        site: 0
    },
    // resource_sms_code:{
    //     url:'/resource/sms/code',//验证码
    //     method: 'get',
    //     site: 1,
    //     // noTrans: true,//json对象格式
    // },
    // auth_login:{
    //     url:'/auth/login',//登陆
    //     method: 'post',
    //     site: 1,
    //     // noTrans: true,//json对象格式
    // },


    //自动获取网点编号接口
    installInfo_newSiteId:{
        url:'/devicemanager/installInfo/newSiteId',
        method: 'get',
        site: 1,
        // noTrans: true,//json对象格式
    },

    file_upload:{
        url:'/file/mobile/upload',//上传文件
        method: 'post',
        site: 1,
        // noTrans: true,//json对象格式
    },
    queryIdNumber:{
        url:'/applicant/queryIdNumber',//
        method: 'get',
        site: 1
    },
    applicant:{
        url: '/applicant',//提交个人资料审核(不包括图片)
        method: 'post',
        site: 1
    },
    information:{
        url:'/information',//上传图片
        method: 'get',
        site: 1
    },
    applicant_insertAll:{
        url:'/applicant/insertAll',//提交个人资料审核(包括图片)
        method: 'post',
        site: 1
    },
    applicant_selectByPrimaryKey:{
        url:'/applicant/selectByPrimaryKey',//审核等待
        method: 'post',
        site: 1
    },
    auditInfo_queryLastAuditInfo:{
        url:'/auditInfo/queryLastAuditInfo',//审核意见
        method: 'post',
        site: 1
    },
    applicant_updateSecondInfo:{
        url:'/applicant/updateSecondInfo',//复审-更新用户提交复审信息及资料（资料为添加）
        method: 'post',
        site: 1,
    },
    applicant_queryAllInfo:{
        url:'/applicant/queryAllInfo',//通过身份证信息查询用户提交信息及资料
        method: 'get',
        site: 1
    },
    applicant_updateAll:{
        url:'/applicant/updateAll',//初审-更新用户提交修改信息及资料（基本资料中状态要修改提交）
        method: 'post',
        site: 1
    },
    applicantScenes_query:{
        url:'/applicantScenes/query',//二审失败后查看失败项
        method: 'get',
        site: 1
    },
    document_query:{
        url:'/document/query',//下载
        method: 'post',
        site: 1
    },
    //文章推送接口
    noticeContent:{
        url:'/notice/noticeContent',//
        method: 'get',
        site: 1
    },


    //语音小助手模块功能接口
    //1.	查询素材
    medium_marketingMaterialsFindByNetwork:{
        url:'/api/marketingMaterials/findByNetwork',
        method: 'post',//
        site: 3
    },
    // 素材统计数量
    medium_marketingMaterialsCountByType:{
        url:'/api/marketingMaterials/countByType',
        method: 'post',//
        site: 3
    },
    // 3.	添加屏保（发布配置）
    medium_deviceScreensaverConfig:{
        url:'/api/deviceScreensaver/config',
        method: 'post',//
        site: 3
    },
    // 4.	查询屏保配置
    medium_deviceScreensaverFindAll:{
        url:'/api/deviceScreensaver/findAll',
        method: 'post',//
        site: 3
    },
    // 5.	启用定时开关机
    medium_powerControlConfig:{
        url:'/api/powerControl/config',
        method: 'post',//
        site: 3
    },
    //6.	查询定时开关机配置
    medium_powerControlByNetWork:{
        url:'/api/powerControl/findByNetwork',
        method: 'get',//
        site: 3
    },
    //7.	启用雷达
    medium_deviceRadarControlConfig:{
        url:'/api/device/radarControl/config',
        method: 'post',//
        site: 3
    },
    // 8.	查询雷达配置
    medium_deviceRadarControlFindByNetwork:{
        url:'/api/device/radarControl/findByNetwork',
        method: 'get',//
        site: 3
    },
    // 10.	通知设备播放音频报警
    medium_audioFileNotify:{
        url:'/api/audioFile/notify?id=1&notify=true',
        method: 'post',//
        site: 3
    },
    // 11. 设置播放音量
    device_playbackVolume_config:{
        url:'/api/device/playbackVolume/config',
        method: 'post',//
        site: 3
    },
    // 12. 查询播放音量
    playbackVolume_findByNetwork:{
        url:'/api/device/playbackVolume/findByNetwork',//?networkId
        method: 'get',//
        site: 3
    },
    // 13.添加个人素材
    marketingMaterials_addPersonalMaterials:{
        url:'/api/marketingMaterials/addPersonalMaterials',
        method: 'post',//请求参数:FormData
        site: 3,
        isFormData:true
        // noTrans: true,//json对象格式
    },
    // 14.修改个人素材
    marketingMaterials_updatePersonalMaterials:{
        url:'/api/marketingMaterials/updatePersonalMaterials',
        method: 'post',//请求参数:FormData
        site: 3,
        isFormData:true
        // noTrans: true,//json对象格式
    },
    // 15.删除个人素材
    marketingMaterials_deletePersonalMaterials:{
        url:'/api/marketingMaterials/deletePersonalMaterials',//?id=?
        method: 'delete',//请求方法:DELETE
        site: 3
    },
    // 16.添加站主二维码
    network_addQrCode:{
        url:'/api/network/addQrCode',
        method: 'post',//请求参数:FormData
        site: 3,
        isFormData:true
        // noTrans: true,//json对象格式
    },
    //17.更新站主二维码到设备
    network_updateQrCodeToDevice:{
        url:'/api/network/updateQrCodeToDevice',//?networkId
        method: 'get',//
        site: 3
    },
    //     大屏配置模块
    // 1.素材上传
    wx_hdmi_material_add:{
        url:'/api/wx/hdmi/material/add',
        method: 'post',//请求参数:FormData
        site: 3,
        isFormData:true
        // noTrans: true,//json对象格式
    },
    //     2.删除素材
    wx_hdmi_material_delete:{
        url:'/api/wx/hdmi/material/delete/',//{id}
        method: 'delete',//请求方法:DELETE
        site: 3
    },
    //     3.素材列表
    wx_hdmi_material_list:{
        url:'/api/wx/hdmi/material/list',
        method: 'get',//请求方法:get
        site: 3
    },
    //     4.查询所有盒子
    wx_hdmi_listAll:{
        url:'/api/wx/hdmi/listAll',
        method: 'get',//请求方法:get
        site: 3
    },
    //     5.查询盒子节目单
    wx_hdmi_programPlan:{
        url:'/api/wx/hdmi/programPlan',
        method: 'get',//请求方法:get
        site: 3
    },
    //    6.创建盒子节目单
    wx_hdmi_programPlan_add:{
        url:'/api/wx/hdmi/programPlan',
        method: 'post',//请求参数:FormData
        site: 3,
        // isFormData:true
        // noTrans: true,//json对象格式
    },
    //    7.修改盒子节目单
    wx_hdmi_programPlan_update:{
        url:'/api/wx/hdmi/programPlan',
        method: 'put',//请求参数:FormData
        site: 3,
        // isFormData:true
        // noTrans: true,//json对象格式
    },
    //   8.删除盒子节目
    wx_hdmi_programPlan_del:{
        url:'/api/wx/hdmi/programPlan',
        method: 'delete',//请求参数:FormData
        site: 3,
        // isFormData:true
        // noTrans: true,//json对象格式
    },
    //    9.节目单素材添加
    wx_hdmi_plan_material_add:{
        url:'/api/wx/hdmi/plan/material/add',
        method: 'post',//请求参数:FormData
        site: 3,
        // isFormData:true
        // noTrans: true,//json对象格式
    },
    //    10.节目单素材修改
    wx_hdmi_plan_material_update:{
        url:'/api/wx/hdmi/plan/material/update',
        method: 'post',//请求参数:FormData
        site: 3,
        // isFormData:true
        // noTrans: true,//json对象格式
    },
    //    11.节目单素材移动
    wx_hdmi_plan_material_move:{
        url:'/api/wx/hdmi/plan/material/move',
        method: 'post',//请求参数:FormData
        site: 3,
        // isFormData:true
        // noTrans: true,//json对象格式
    },
    //     12.节目单素材删除
    wx_hdmi_plan_material_del:{
        url:'/api/wx/hdmi/plan/material/delete',// /{id}
        method: 'delete',//请求参数:FormData
        site: 3,
        // isFormData:true
        // noTrans: true,//json对象格式
    },
    //     13.节目单推送
    wx_hdmi_programPlan_push:{
        url:'/api/wx/hdmi/programPlan/push',
        method: 'get',
        site: 3,
    },
};
